import { type MCPServerInfo } from '../../types';

const OktaCommunityServer: MCPServerInfo = {
  serverId: 'OKTA_COMMUNITY',
  name: 'Okta Community',
  slug: 'okta-community',
  description: 'Okta MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'https://github.com/kapilduraphe/okta-mcp-server',
    commitSha: 'd53f5d7',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['oktaApiToken', 'oktaOrgUrl'],
    properties: {
      oktaApiToken: {
        type: 'string',
        description: 'Okta API Token',
        sensitive: true
      },
      oktaOrgUrl: {
        type: 'string',
        description: 'Okta Organization URL',
        sensitive: false
      }
    }
  }
};

export default OktaCommunityServer;
